<template>
    <div class="memberRuleBox">
        <!--<div class="memberRuleNav">-->
        <!--<i class="iconfont iconzuojiantou" @click="returnFn"></i>-->
        <!--</div>-->
        <div class="imgLogoBox">
            <div class="scrollBox">

                <img class="imgStyle" src="../../../assets/img/logo.png" alt="logo">
                <div class="margin-15">
                    <h1 class="title" style="white-space:pre-line" v-if="ruleDataList.topic">{{ruleDataList.topic}}</h1>
                    <img v-if="ruleDataList.topicPic" :src="`/manager/fileserver/file/download?id=${ruleDataList.topicPic}`">
                    <p class="content" style="white-space:pre-line">
                        {{ruleDataList.desc}}
                    </p>

                    <div v-for="(item, index) in ruleDataList.contentItems" :key="index">
                        <h2 class="subtitle" v-if="item.topic">{{item.topic}}</h2>
                        <p class="content" style="white-space:pre-line">
                            {{item.desc}}
                        </p>
                        <div v-for="(v, idx) in item.pics" :key="idx">
                            <img :src="`/manager/fileserver/file/download?id=${v}`">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "memberRule2",
        created(){
            this.ruleList = JSON.parse(this.$route.query.itemData)
        },
        mounted() {
            document.title = "会员规则"
            let dt = new URLSearchParams()
            dt.append('id', this.ruleList.id)
            this.$http.post('/system/base/content/getById',dt).then(({data})=>{//获取会员规则详情

                this.ruleDataList = data.data
            })


        },
        data(){
            return{
                ruleList:'',
                ruleDataList:'', //会员规则详情
            }
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped>
    .memberRuleBox{
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #fff;
        .imgLogoBox{
            position: absolute;
            /*top: 45px;*/
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            .scrollBox{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #fff;
            }
            .imgStyle{
                width: 55%;
                margin: 20px;
            }
            .margin-15 {
                margin: 15px;
                width: 90%;
            }
            .subtitle{
                font-size: 22px;
                font-weight: bold;
                line-height: 60px;
                background-color: #0dd2ee;
                color: white;
                margin: 20px 0;
                list-style: none;
                padding: 0;
                text-indent: 1em;
            }
            img{
                width: 100%;
            }
            .content{
                text-indent: 2em;
                line-height: 23px;
            }
            /*.ruleContnet{*/
            /*width: 90%;*/
            /*}*/
            /*.ruleTitle{*/
            /*font-size: 14px;*/
            /*color: #222;*/
            /*font-weight: 600;*/
            /*}*/
            /*.modulText{*/
            /*margin-top: 20px;*/
            /*background-color: #fff;*/
            /*}*/
            /*.flootText{*/
            /*margin-top: 50px;*/
            /*padding-bottom: 20px;*/
            /*}*/
        }
        /*p{*/
        /*font-size: 12px;*/
        /*color: #444;*/
        /*line-height: 22px;*/
        /*}*/
    }
</style>
